import { Typography } from "@mui/material";
import MyDivider from "src/components/layout/MyDivider";
import PropTypes from "prop-types";

export default function ProcessSubHeadingRow(props) {
  //if (!props.show) return null;
  return (
    <>
      <Typography color="primary" variant="h7" className="noPrint">
        {props.txt}
      </Typography>
      <MyDivider gutterBottom />
    </>
  );
}

ProcessSubHeadingRow.propTypes = {
  txt: PropTypes.string,
  show: PropTypes.bool,
};
